import React, { Component } from 'react';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';
import notFavorited from '../../ASUPhotos/icons/me3_Heart_Outline_Icon.svg';
import favorited from '../../ASUPhotos/icons/me3_Heart_Filled_Icon.svg';
import {
  addFavorite,
  removeFavorite,
  getCurrentUserId,
} from '../../store/actions';
import { getAuthState, getOnboardingState } from '../../store/selectors';

const buttonStyles = (imgUrl, location) => {
  return {
    backgroundImage: `url(${imgUrl})`,
    backgroundSize: 'cover',
    backgroundColor: 'transparent',
    height: '20px',
    width: '20px',
    marginTop: '1px',
    border: 'none',
    cursor: `${location ? 'default' : 'pointer'}`,
    backgroundPosition: 'center',
    display: 'block',
  };
};

class Favorite extends Component {
  constructor(props) {
    super(props);
    this.state = {
      careerFavoritedState: false,
    };
  }

  careerIsFavorited = (careerId) => {
    if (this.props.location?.pathname.includes('user-profile')) {
      if (
        this.props.userProfileFavorites &&
        this.props.userProfileFavorites.length === 0
      ) {
        return false;
      }

      return this.props.userProfileFavorites?.some(
        (favorite) => favorite.career_id === careerId
      );
    }
    if (Object.keys(this.props.onboarding.favorites).length === 0) {
      return false;
    }

    return this.props.onboarding.favorites.some(
      (favorite) => favorite.career_id === careerId
    );
  };

  componentDidMount = async () => {
    if (!this.props.onboarding.userData) {
      await this.props.getCurrentUserId(this.props.auth.jwtToken);
    }
    if (this.props.careerId) {
      const initialCareerFavoriteCheck = this.careerIsFavorited(
        this.props.careerId
      );
      this.setState({
        careerFavoritedState: initialCareerFavoriteCheck,
      });
    }
  };

  // Need to check for favorites when props.careerId is updated
  componentDidUpdate = async (prevProps, prevState) => {
    /* eslint-disable */
    if (this.props.careerId) {
      const updateCareerFavoriteCheck = this.careerIsFavorited(
        this.props.careerId
      );
      /* eslint-disable */
      if (prevState.careerFavoritedState !== updateCareerFavoriteCheck)
        this.setState({
          careerFavoritedState: updateCareerFavoriteCheck,
        });
    }
    /* eslint-enable */
  };

  handleCareerFavorited = async (favoriteAction) => {
    try {
      // When prev user logs back in sometimes the userdata{} isn't set
      const userId = !isEmpty(this.props.onboarding.userData)
        ? this.props.onboarding.userData.user.id
        : this.props.onboarding.userId;
      let favoriteResponse;

      if (favoriteAction === 'add') {
        favoriteResponse = await this.props.addFavorite(
          this.props.auth.jwtToken,
          userId,
          this.props.careerId,
          this.props.career
        );
      }

      if (favoriteAction === 'remove') {
        favoriteResponse = await this.props.removeFavorite(
          userId,
          this.props.auth.jwtToken,
          this.props.careerId
        );
      }

      const foundFavoritedCareer = favoriteResponse.data.data.favorites.some(
        (favorite) => favorite.career_id === this.props.careerId
      );
      this.setState({
        careerFavoritedState: foundFavoritedCareer,
      });
    } catch (err) {
      console.log('Unable to handle career favoriting: ', err);
    }
  };

  render() {
    return (
      <>
        {this.state.careerFavoritedState ? (
          <button
            type="button"
            tabIndex={0}
            aria-label={`Click here or press enter to unfavorite this career: ${this.props.careerName}`}
            style={buttonStyles(
              favorited,
              this.props.location?.pathname.includes('user-profile')
            )}
            onClick={() => this.handleCareerFavorited('remove')}
            onKeyDown={(e) => {
              if (['Enter'].includes(e.key)) {
                this.handleCareerFavorited('remove');
              }
            }}
            disabled={this.props.location?.pathname.includes('user-profile')}
          />
        ) : (
          <button
            type="button"
            tabIndex={0}
            aria-label={`Click here or press enter to favorite this career: ${this.props.careerName}`}
            style={buttonStyles(
              notFavorited,
              this.props.location?.pathname.includes('user-profile')
            )}
            onClick={() => this.handleCareerFavorited('add')}
            onKeyDown={(e) => {
              if (['Enter'].includes(e.key)) {
                this.handleCareerFavorited('add');
              }
            }}
            disabled={this.props.location?.pathname.includes('user-profile')}
          />
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const onboarding = getOnboardingState(state);
  const auth = getAuthState(state);

  return { auth, onboarding };
};

export default connect(mapStateToProps, {
  addFavorite,
  removeFavorite,
  getCurrentUserId,
})(Favorite);
